import * as React from "react";
import type { SVGProps } from "react";
const SvgCompletedStepIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24" {...props}
  >
    <rect width={24} height={24} x={0.5} fill="#B0D2FF" rx={12} />
    <path
      stroke="#0C21A3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.667 10 11.5 14.167l-2.5-2.5"
    />
  </svg>
);
export default SvgCompletedStepIcon;
